module.exports = __webpack_public_path__ + "static/media/normal.6f761c44.svg";